import React from "react";
import "./progress.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Kawasanimages from "./kawasan.js";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faGraduationCap,
  faHouse,
  faMapPin,
} from "@fortawesome/free-solid-svg-icons";

const lokasi = () => {
  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="progress" className="progressfscg">
      <div className="containerprogressfscg">
        <div className="judul-progressfscg">
          <h1>Progress of Summarecon Crown Gading</h1>
          <h2>Tersedia Rumah Siap Huni, Free PPN</h2>
        </div>
        <div className="container-progressfscg">
          <div className="kartu">
            <Slider {...settings}>
              {Kawasanimages.map((image, index) => (
                <div>
                  <img
                    className="kartugambar1"
                    key={index}
                    src={image}
                    alt="athena"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default lokasi;
